import { OrderLineDetail } from '@ravago/shared/page-data/models/elements';

export async function getOrderLine(orderId: number, orderNumber: number): Promise<OrderLineDetail | undefined> {
  const response = await fetch(`/api/orders/${orderId}/order-lines/${orderNumber}`);

  if (!response.ok) {
    return undefined;
  }

  return response.json();
}
